import RequestBuilder from "../RequestBuilder"
import {Method} from "../enum/Method"
import {CompletionOptionsJson} from "../json/CompletionOptionsJson"
import {AnyModelSpecJson} from "../json/ModelSpecJson"
import TransformJobJson from "../json/TransformJobJson"

/**
 * Destination for a new transform job. Exactly one of:
 *  - kind: 'new'       → create a new text field with this name + reference
 *  - kind: 'existing'  → target an existing text field; values on every row are overwritten
 */
export type TransformJobDestination =
    | { kind: 'new', name: string, reference: string }
    | { kind: 'existing', fieldId: string }

export class TransformJobRequests {
    static create(
        projectId: string,
        transformId: string,
        destination: TransformJobDestination,
        modelSpec: AnyModelSpecJson,
        completionOptions: CompletionOptionsJson,
    ): Promise<TransformJobJson> {
        const destinationPayload = destination.kind === 'new'
            ? {name: destination.name, reference: destination.reference}
            : {existingColumnId: destination.fieldId}

        return new RequestBuilder(Method.Post, `projects/${projectId}/transform-jobs`)
            .withJson({
                transformId: transformId,
                destination: destinationPayload,
                baseModelPlatform: modelSpec.platform,
                baseModelName: modelSpec.name,
                completionOptions: completionOptions,
            })
            .buildAndSend()
    }

    static get(projectId: string, transformJobId: string): Promise<TransformJobJson> {
        return new RequestBuilder(Method.Get, `projects/${projectId}/transform-jobs/${transformJobId}`)
            .buildAndSend()
    }

    static cancel(
        projectId: string,
        transformJobId: string,
    ): Promise<TransformJobJson> {
        return new RequestBuilder(Method.Post, `projects/${projectId}/transform-jobs/${transformJobId}/cancels`)
            .buildAndSend()
    }
}
